// extracted by mini-css-extract-plugin
export default {"wrapper":"ReassignModal_wrapper__8gAE5","iconWrapper":"ReassignModal_iconWrapper__uNJEI","heading":"ReassignModal_heading__o+JJP","footerBtn":"ReassignModal_footerBtn__YCN6E"};